var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("competence-cards-list-loading")
        : _vm.anyCompetenceCards
        ? _c("list-component", {
            staticClass:
              "c-list-component--competence-cards  t-background-white-grey",
            attrs: { rows: _vm.competenceCards }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }